(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hotspots"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded",function () {
theme.reinitProductGridItem();
                });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  // Gender filter button functionality
  function initGenderFilterButtons() {
    // Find all gender filter buttons
    var genderButtons = document.querySelectorAll('[data-ajax-filter]');
    
    // Add click event listeners to each button
    genderButtons.forEach(function(button) {
      // Remove existing listeners to prevent duplicates
      button.removeEventListener('click', handleGenderFilterClick);
      
      // Add new listener
      button.addEventListener('click', handleGenderFilterClick);
    });
  }
  
  function handleGenderFilterClick(event) {
    event.preventDefault();
    
    // Get the URL from the button's href attribute
    var url = new URL(this.href);
    
    // Find the collection container
    var collectionContainer = document.querySelector('.collection-content');
    if (!collectionContainer) return;
    
    // Add loading state
    collectionContainer.classList.add('is-loading');
    
    // Find the collection instance
    var collectionInstance = null;
    if (window.theme && window.theme.sections && window.theme.sections.instances) {
      collectionInstance = window.theme.sections.instances.find(function(instance) {
        return instance.type === 'collection-grid';
      });
    }
    
    // If we found the collection instance, use its AJAX methods
    if (collectionInstance && collectionInstance.renderCollectionPage) {
      // Use the theme's built-in method
      collectionInstance.renderCollectionPage(url.searchParams);
    } else {
      // Fallback to our own AJAX implementation
      fetch(url)
        .then(function(response) {
          return response.text();
        })
        .then(function(html) {
          // Parse the response HTML
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          
          // Get the new collection content
          var newContent = doc.getElementById('CollectionAjaxContent');
          if (!newContent) {
            window.location.href = url.href;
            return;
          }
          
          // Update the collection content
          document.getElementById('CollectionAjaxContent').innerHTML = newContent.innerHTML;
          
          // Update the URL without reloading the page
          history.pushState({}, '', url.href);
          
          // Reinitialize any necessary components
          if (window.theme && window.theme.sections) {
            window.theme.sections.reinit('collection-grid');
          }
          
          // Remove loading state
          collectionContainer.classList.remove('is-loading');
          
          // Dispatch an event to notify that the collection was reloaded
          document.dispatchEvent(new CustomEvent('collection:reloaded'));
        })
        .catch(function(error) {
          // If there was an error, just navigate to the URL
          window.location.href = url.href;
        });
    }
  }

  // Initialize the gender filter buttons when the DOM is loaded
  document.addEventListener('DOMContentLoaded', initGenderFilterButtons);
  
  // Also initialize when the collection is reloaded via AJAX
  document.addEventListener('collection:reloaded', initGenderFilterButtons);

  } catch(e) { console.error(e); }
})();
})();
